import React from 'react';
import Main from './main';

const EditExpenseApplication = (props) => {
  const [expenseApplication, setExpenseApplication] = React.useState(props.expense_application);
  const [expenseApplicationImages, setExpenseApplicationImages] = React.useState(props.expense_application_images || []);
  const [event] = React.useState(props.event);
  const [circle] = React.useState(props.circle);
  const [company] = React.useState(props.company);

  return (
    <div className="container-for-circles-menu container col-lg-8 text-fz-14px text-fw-bold text-black-50">
      <div className="block block-rounded my-4 ml-0 mr-0">
        <div className="pt-0 block-content pl-2 pr-2 pb-0 pt-5">
          <Main
            props={props}
            expenseApplication={expenseApplication}
            setExpenseApplication={setExpenseApplication}
            expenseApplicationImages={expenseApplicationImages}
            setExpenseApplicationImages={setExpenseApplicationImages}
            event={event}
            circle={circle}
            company={company}
          />
        </div>
      </div>
    </div>
  );
};

export default EditExpenseApplication;
